import { inject } from '@angular/core'
import { CanDeactivateFn } from '@angular/router'

import { Store } from '@ngrx/store'

import { Observable, map, tap } from 'rxjs'

import { AiActions } from '@flowx/designer/modules/new-ai/store/ai.actions'
import { ConfirmationModalComponent } from '@flowx/designer/shared/components/confirmation-modal/confirmation-modal.component'
import { FlxModalService } from '@flowx/angular-ui-toolkit'

import { showAiModal } from '../services/ai-modal.service'

export interface AiCanDiscardContext {
  aiCanDiscardContext: () => boolean | Observable<boolean>
}

export function confirmDiscardContext(params?: {
  message?: string
  onSuccess?: () => unknown
}): Observable<boolean> {
  const modalService = inject(FlxModalService)
  const store = inject(Store)

  const modal = showAiModal(
    modalService,
    ConfirmationModalComponent,
    {
      closeOnBackdropClick: false,
    },
    {
      message:
        params?.message ??
        `You are about to remove the document from AI Context. <br/> Are you sure you want to leave?`,
      btnOkText: `I'm sure`,
    }
  )

  return modal.data$.pipe(
    tap((data: { confirm }) => {
      if (data.confirm) {
        if (params?.onSuccess) {
          params?.onSuccess()
        }
        store.dispatch(AiActions.closeContextDocumentConfirmed())
      }
    }),
    map((data: { confirm }) => data.confirm)
  )
}

export function pendingAiContext(): CanDeactivateFn<AiCanDiscardContext> {
  return (component: AiCanDiscardContext) => {
    if (!component || component.aiCanDiscardContext()) {
      return true
    }

    return confirmDiscardContext()
  }
}
